import { Header } from "Components";

const HeaderContent = {
  title: "Luke Weathington",
  subtitle: "Woodwinds | Education",
  showGifs: true,
  element: <Header />,

  // Update fontSize, fontFamily, fontWeight, color, etc.
  titleStyle: {},
  subTitleStyle: {},
  navigationStyle: {},
  menuStyle: {},
};

export default HeaderContent;
